import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { useUISize } from 'app/utils/web-helpers';
import { useEffect } from 'react';
import { ChooseSharerTypeScreen as ChooseSharerTypeScreenSmall } from './choose-sharer-type.small';
import { ChooseSharerTypeScreen as ChooseSharerTypeScreenLarge } from './choose-sharer-type.large';

export const ChooseSharerTypeScreen: typeof ChooseSharerTypeScreenSmall = (props) => {
  const { isSmallUI } = useUISize();

  useEffect(() => {
    if (isWhiteLabel(WhiteLabel.HauteGaspesie)) {
      props.navigation.replace('guidelines', { hideCross: props.route.params?.hideCross });
    }
  }, [props.navigation, props.route.params?.hideCross]);

  if (isWhiteLabel(WhiteLabel.HauteGaspesie)) {
    return null;
  }

  if (isSmallUI) {
    return <ChooseSharerTypeScreenSmall {...props} />;
  }
  return <ChooseSharerTypeScreenLarge {...props} />;
};
